import React from 'react'
import './styles'

import { Link } from 'react-router-dom'

# components
import Spinner    from '/components/spinner'
import Empty      from '/components/empty'
import List       from '/components/list'
import StateLabel from '/components/state-label'
import Datetime   from '/components/datetime'

import { withTransfer } from './queries'

# Two views of the same order: other attempts to move this exact cost item, and
# transfers of everything else on the order.
export default \
withTransfer \
class Related extends React.Component

  render: ->
    return <Spinner/> if @props.transferLoading
    return <Empty name="Transfer" /> unless @props.transfer?.id

    <div className="Related">
      {@section 'Same cost item', (@props.transfer.related_transfers or []),
        'No other transfers of this cost item.'}
      {@section 'Rest of the order', (@props.transfer.sibling_transfers or []),
        'Nothing else on this order has been transferred.'}
    </div>

  section: (title, transfers, empty) ->
    <div className="related-section" key={title}>
      <h2>{title} <span className="badge">{transfers.length}</span></h2>
      {if transfers.length
        @list transfers
      else
        <p className="muted">{empty}</p>
      }
    </div>

  list: (transfers) ->
    <List>
      {@header()}
      {for transfer in transfers
        <List.Row key={transfer._key}>
          <List.Cell className="id">
            <Link className="btn btn-default" to={"/transfers/#{transfer.id}"}>
              More info
            </Link>
          </List.Cell>
          <List.Cell className="transfer-to">
            {transfer.name}
            <br/>
            {transfer.email}
          </List.Cell>
          <List.Cell className="cost-item">
            <samp>...{transfer.original_cost_item?.id?.slice -6}</samp>
            <br/>
            <small>{transfer.original_cost_item?.name}</small>
          </List.Cell>
          <List.Cell className="transferred-date">
            <Datetime date={transfer.created_at}/>
          </List.Cell>
          <List.Cell className="accepted-by">
            {transfer.accepted_by_name}
            <br/>
            {transfer.accepted_by_email}
          </List.Cell>
          <List.Cell className="state">
            <StateLabel model={transfer}/>
          </List.Cell>
        </List.Row>
      }
    </List>

  header: ->
    <List.HeaderRow>
      <List.Header className="id"></List.Header>
      <List.Header className="transfer-to">Transfer To</List.Header>
      <List.Header className="cost-item">Cost Item</List.Header>
      <List.Header className="transferred-date">Started</List.Header>
      <List.Header className="accepted-by">Accepted By</List.Header>
      <List.Header className="state">Status</List.Header>
    </List.HeaderRow>
